<template>
  <div class="d-flex flex-column justify-center">
    <v-tooltip
      bottom
      :disabled="!hasContent">
      <template v-slot:activator="{ on, attrs }">
        <div
          :class="contentClasses"
          :style="wrapperStyle"
          v-bind="attrs"
          v-on="on">
          <span
            class="cellLine"
            :style="lineStyle">
            {{ displayText }}
          </span>
        </div>
      </template>

      <span>
        {{ displayTooltipText }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'OneLineCell',
  props: {
    text: { type: [String, Number], default: null },
    tooltipText: { type: [String, Number], default: null },
    firstLine: { type: [String, Number], default: null },
    textClass: { type: [String, Array, Object], default: '' },
    firstLineClass: { type: [String, Array, Object], default: '' },
    textStyle: { type: [String, Object], default: '' },
    firstLineStyle: { type: [String, Object], default: '' },
    wrapperClass: { type: [String, Array, Object], default: '' },
    wrapperStyle: { type: [String, Object], default: '' },
    useFlexLayout: { type: Boolean, default: true },
    defaultNoValue: { type: String, default: '' },
  },
  computed: {
    displayText() {
      const resolved = this.text !== null && this.text !== undefined
        ? this.text
        : this.firstLine;
      return resolved ?? this.defaultNoValue;
    },
    displayTooltipText() {
      const text =
        this.tooltipText ??
        this.text ??
        this.firstLine;

      return text ?? this.defaultNoValue;
    },
    hasContent() {
      const value = this.displayText;
      return value !== null && value !== undefined && String(value).trim().length > 0;
    },
    contentClasses() {
      const classes = [];
      if (this.useFlexLayout) {
        classes.push('d-flex', 'flex-column');
      }
      classes.push('cellContent');

      if (this.wrapperClass) {
        classes.push(this.wrapperClass);
      }

      if (this.textClass) {
        classes.push(this.textClass);
      } else if (this.firstLineClass) {
        classes.push(this.firstLineClass);
      }

      return classes;
    },
    lineStyle() {
      return this.textStyle || this.firstLineStyle || '';
    },
  },
};
</script>

<style scoped>
.cellContent {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cellLine {
  min-height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  color: inherit;
}
</style>
